"use client";

import { useEffect, useRef } from "react";
import Clarity from "@microsoft/clarity";
import { useAuth } from "@/hooks/useAuth";

const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;

/**
 * Инициализация Microsoft Clarity на клиенте.
 * После логина — identify(user.id) и тег company_id (без email/PII).
 * Работает только если задан NEXT_PUBLIC_CLARITY_PROJECT_ID.
 */
export function ClarityInit() {
  const { user, isLoading } = useAuth();
  const inited = useRef(false);

  useEffect(() => {
    if (!projectId || inited.current) return;
    Clarity.init(projectId);
    inited.current = true;
  }, []);

  useEffect(() => {
    if (!projectId || isLoading || !user) return;

    Clarity.identify(user.id);
    Clarity.setTag("company_id", user.company_id);

    if (user.company?.client_code) {
      Clarity.setTag("client_code", user.company.client_code);
    }
    if (user.role) {
      Clarity.setTag("role", user.role);
    }
  }, [isLoading, user]);

  return null;
}
